<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            fixed
            prop="merchantsName"
            label="农基商名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="merchantsClassify"
            label="农基商类型"
            width="180">
    </el-table-column>
    <el-table-column
            prop="inTime"
            label="入驻时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="name"
            label="联系人"
            width="180">
    </el-table-column>
    <el-table-column
            prop="email"
            label="邮箱"
            width="180">
    </el-table-column>
    <el-table-column
            prop="detailAddress"
            label="农基区域"
            width="300">
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
        <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
        <el-button type="text" size="small" @click="del(scope.row.id)">
          <p class="red">删除</p>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import {delByMerchantsId} from "../../network/merchants";

  export default {
    name: "MerchantsTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$router.push("/merchants/data/"+id)
      },
      update(id){
        this.$router.push("/merchants/insert/"+id)
      },
      del(id){
        this.$confirm('此操作将永久删除该农基商, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit("del",id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
